const CustomDefaultShowComponent = <span className="text-secondary" style={{ fontStyle: 'italic' }}>None</span>;

export default CustomDefaultShowComponent;